/**
 * @generated SignedSource<<4cc1a484d12fb20a3800c6458d00b834>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedExcellentValuesCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedExcellentValuesCarousel_user";
};
export type HpSharedExcellentValuesCarousel_user$key = {
  readonly " $data"?: HpSharedExcellentValuesCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedExcellentValuesCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedExcellentValuesCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d36254ad578cee3fb09e5a4d52e80971";

export default node;
